// Title matching is forgiving about form but not about wording (CLAUDE.md,
// Title matching): capitals, punctuation, accents and "&" vs "and" are ignored;
// misspellings are not. The sync stores these keys and the website compares
// against them, so both sides must use this one function.
export function normaliseTitle(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9 ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

// Search keys for one title: its display title and each alternative, normalised
// and de-duplicated. A title whose only forms are in a non-Latin script (e.g.
// 기생충) normalises to nothing and contributes no key.
export function searchKeys(titles: Iterable<string | null | undefined>): string[] {
  const keys = new Set<string>();
  for (const t of titles) {
    if (!t) continue;
    const key = normaliseTitle(t);
    if (/[a-z0-9]/.test(key)) keys.add(key);
  }
  return [...keys];
}
